


const data = {
  serial: '',
  name: 'Astro Switch Test',
  type: 'ANC2',
  alive: true,
  lastSeen: new Date().toISOString(),
  timeZone: 'Europe/Madrid',
  firmware: '1.0.3',
  location: {
    country: 'Spain',
    region: 'Madrid',
    city: 'Madrid',
    lat: 40.4168,
    lon: -3.7038
  },

  // Single output device
  output1: true,

  // Instant electrical parameters
  electricalParams: {
    voltage_V: 230.5,
    current_A: 1.36,
    power_W: 285.2,
    energy_kWh: 1540.2,
    frequency_Hz: 50.0,
    temperature_C: 38.7
  },

  // Counters and energy statistics
  counters: {
    totalRunHours_h: 1325.4,
    partialRunHours_h: 52.8,
    partialActiveEnergy_kWh: 14.6,
    totalActiveEnergy_kWh: 1540.2,
    lastPartialReset: '2025-09-30T00:00:00Z',
    lastReset: '2024-01-01T00:00:00Z'
  },

  // Scheduler configuration
scheduler: {
  output1: [
    // Lunes a viernes → encendido al ocaso (~18:40)
    {
      type: 'sunset',
      time: '18:40', // ocaso estimado
      offset: 0,
      days: 31, // Lunes a Viernes (1+2+4+8+16)
      action: 1
    },

    // Martes a sábado → apagado al amanecer (~07:20)
    {
      type: 'sunrise',
      time: '07:20', // orto estimado
      offset: 0,
      days: 62, // Martes a Sábado (2+4+8+16+32)
      action: 0
    },

    // Sábado y domingo → encendido fijo 12:00
    {
      type: 'fixed',
      time: '12:00',
      offset: 0,
      days: 96, // Sábado + Domingo (32+64)
      action: 1
    },

    // Sábado y domingo → apagado fijo 20:00
    {
      type: 'fixed',
      time: '17:00',
      offset: 0,
      days: 96, // Sábado + Domingo (32+64)
      action: 0
    }
  ]
},



  // Alarm configuration
  config: {
    overcurrentAlarm: {
      enabled: true,
      threshold_A: 3.5,
      hysteresis_A: 0.3,
      delay_ms: 2000
    },
    temperatureAlarm: {
      enabled: true,
      threshold_C: 70,
      deactivationTemp_C: 60,
      delay_ms: 3000
    }
  },

  //  HISTORY
  history: [
    // Recent 7-day operation cycles
    {
      start: '2025-10-16T18:40:00Z',
      end: '2025-10-17T07:20:00Z',
      duration_h: 12.67,
      energy_kWh: 3.55,
      avgPower_W: 280,
      maxPower_W: 360
    },
    {
      start: '2025-10-17T18:40:00Z',
      end: '2025-10-18T07:20:00Z',
      duration_h: 12.67,
      energy_kWh: 3.42,
      avgPower_W: 272,
      maxPower_W: 348
    },
    {
      start: '2025-10-18T18:40:00Z',
      end: '2025-10-19T07:20:00Z',
      duration_h: 12.67,
      energy_kWh: 3.68,
      avgPower_W: 287,
      maxPower_W: 372
    },
    {
      start: '2025-10-19T18:40:00Z',
      end: '2025-10-20T07:20:00Z',
      duration_h: 12.67,
      energy_kWh: 3.61,
      avgPower_W: 284,
      maxPower_W: 365
    },
    {
      start: '2025-10-20T18:40:00Z',
      end: '2025-10-21T07:20:00Z',
      duration_h: 12.67,
      energy_kWh: 3.49,
      avgPower_W: 277,
      maxPower_W: 350
    },
    {
      start: '2025-10-21T18:40:00Z',
      end: '2025-10-22T07:20:00Z',
      duration_h: 12.67,
      energy_kWh: 3.63,
      avgPower_W: 286,
      maxPower_W: 370
    },
    {
      start: '2025-10-22T18:40:00Z',
      end: null, // still active today
      duration_h: null,
      energy_kWh: null,
      avgPower_W: null,
      maxPower_W: null
    },

    // Monthly / yearly samples
    {
      start: '2025-09-28T18:40:00Z',
      end: '2025-09-29T07:20:00Z',
      duration_h: 12.67,
      energy_kWh: 3.57,
      avgPower_W: 281,
      maxPower_W: 360
    },
    {
      start: '2025-07-10T18:40:00Z',
      end: '2025-07-11T07:20:00Z',
      duration_h: 12.67,
      energy_kWh: 2.95,
      avgPower_W: 270,
      maxPower_W: 335
    },
    {
      start: '2025-01-12T18:40:00Z',
      end: '2025-01-13T07:20:00Z',
      duration_h: 12.67,
      energy_kWh: 3.05,
      avgPower_W: 272,
      maxPower_W: 330
    }
  ]
};

export default data;
